import React, { useState, useEffect } from 'react';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if the user has already accepted cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    
    if (!cookiesAccepted) {
      // Show the cookie consent bar if not accepted
      setShowConsent(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    // Set a flag in localStorage to indicate cookies are accepted
    localStorage.setItem('cookiesAccepted', 'true');
    setShowConsent(false); // Hide the consent bar
  };

  return (
    <>
      {showConsent && (
        <div className="cookie-consent-bar">
          <p>
            We use cookies to provide a better user experience. By using this site, you agree to our use of cookies. 
            <a href="/privacypolicy" target="_blank" rel="noopener noreferrer">Learn more</a>
          </p>
          <button className="accept-button" onClick={handleAcceptCookies}>
            Accept Cookies
          </button>
        </div>
      )}
    </>
  );
}

export default CookieConsent;
